import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { WHATSAPP_URL } from "./CTAButtons";
import WhatsAppIcon from "./WhatsAppIcon";

export default function FloatingQuote() {
  const [open, setOpen] = useState(false);
  return (
    <div className="hidden md:flex flex-col items-end gap-3 fixed bottom-8 right-8 z-40" data-testid="floating-quote">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            className="flex flex-col gap-2"
          >
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-head font-bold uppercase tracking-wide text-sm bg-white text-[#25D366] border border-[#25D366] shadow-lg px-5 h-11 rounded-lg inline-flex items-center gap-2 hover:bg-[#25D366] hover:text-white transition-colors"
              data-testid="floating-whatsapp"
            >
              <WhatsAppIcon className="h-4 w-4" /> WhatsApp Us
            </a>
            <Link
              to="/request"
              className="font-head font-bold uppercase tracking-wide text-sm bg-ink text-white shadow-lg px-5 h-11 rounded-lg inline-flex items-center gap-2 hover:bg-ink-light transition-colors"
              data-testid="floating-getquote"
            >
              Request a Quote
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Quick contact"
        data-testid="floating-toggle"
        className="grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/40 hover:bg-[#128C7E] transition-colors"
      >
        {open ? <X className="h-6 w-6" /> : <WhatsAppIcon className="h-7 w-7" />}
      </button>
    </div>
  );
}
